import PropTypes from 'prop-types';
import React from 'react';

const FieldGroup = ({title, children, className}) => {
  return (
    <div className="field-group">
      <div className="field-group-title">{title}</div>
      <div className={`field-group-container ${className}`}>{children}</div>
    </div>
  );
};

FieldGroup.propTypes = {
  // Title of the field group
  title: PropTypes.string.isRequired,
  // List of field elements to render
  children: PropTypes.node.isRequired,
};

export default FieldGroup;
